import { render, staticRenderFns } from "./DetailCountry.vue?vue&type=template&id=21c37cdd&scoped=true&"
import script from "./DetailCountry.vue?vue&type=script&lang=js&"
export * from "./DetailCountry.vue?vue&type=script&lang=js&"
import style0 from "./DetailCountry.vue?vue&type=style&index=0&id=21c37cdd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c37cdd",
  null
  
)

export default component.exports